// extracted by mini-css-extract-plugin
export default {"starfield":"Starfield_starfield__HN5BD","star":"Starfield_star__Z6k5K","twinkle":"Starfield_twinkle__DH+Og","starDrift":"Starfield_starDrift__RD5b-"};